export { default } from 'crehana-ui/LazyImage/getImgxUrl';
